import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49ebb9b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"demo-1-hero\" data-v-49ebb9b4><div class=\"container\" data-v-49ebb9b4><div class=\"row vcenter\" data-v-49ebb9b4><div class=\"col-lg-12\" data-v-49ebb9b4><div class=\"hero-content\" data-v-49ebb9b4><h2 data-delay=\"40\" style=\"font-size:32px;\" data-v-49ebb9b4> ADVANCED (<span class=\"title_1\" data-v-49ebb9b4>A</span>I-<span class=\"title_1\" data-v-49ebb9b4>D</span>riven de<span class=\"title_1\" data-v-49ebb9b4>V</span>elopment and <span class=\"title_1\" data-v-49ebb9b4>A</span>ssessme<span class=\"title_1\" data-v-49ebb9b4>N</span>t of health<span class=\"title_1\" data-v-49ebb9b4>C</span>are guid<span class=\"title_1\" data-v-49ebb9b4>E</span>lines and stan<span class=\"title_1\" data-v-49ebb9b4>D</span>ards) </h2><p class=\"mt20\" data-delay=\"600\" style=\"font-size:16px;\" data-v-49ebb9b4> ADVANCED - 人工智能驱动的健康指南和标准的制订与评估 </p></div></div></div></div></section>", 1)
const _hoisted_2 = {
  class: "sec-pad position-relative",
  style: {"margin-bottom":"70px"}
}
const _hoisted_3 = { class: "container index-up" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = { class: "contactusblockpair-1 shadow roundimg" }
const _hoisted_7 = { class: "formblockz" }
const _hoisted_8 = { class: "form-block rundalform" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb10" }, "上传文件", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb30" }, "目前支持 WORD和PDF", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { id: "filelist" }, null, -1))
const _hoisted_12 = {
  action: "#",
  id: "contactform",
  method: "post",
  "data-gtm-form-interact-id": "0"
}
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = {
  class: "",
  style: {"margin-top":"20px","text-align":"left"}
}

import { ref,toRaw,reactive, onMounted, watch } from 'vue';
  import { genFileId ,ElLoading,ElMessage} from 'element-plus';
  import type { UploadFile, UploadInstance, UploadProps, UploadRawFile } from 'element-plus';
  import { promptsList} from "../api/modules/api.prompts";
 
  
  const __default__ = {
    name: 'IndexView',
  };
  
  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  const promptsValue = ref('')
  const llmValue = ref('')
  const promptsOptions = ref([])
  const llmOptions = ref([
    {value:"o1-mini",label:'o1-mini'},
    {value:'gpt-4o',label:'gpt-4o'},
    {value:'gpt-4-0125-preview',label:'gpt-4-0125-preview'},
    {value:'gpt-4-1106-preview',label:'gpt-4-1106-preview'},
    {value:'gpt-3.5-turbo-0125',label:'gpt-3.5-turbo-0125'},
    {value:'gpt-3.5-turbo-1106',label:'gpt-3.5-turbo-1106'},
    {value:'deepseek-chat',label:'deepseek-chat'},
    {value:'claude-3-opus-20240229',label:'claude-3-opus-20240229'},
    {value:'claude-3-sonnet-20240229',label:'claude-3-sonnet-20240229'},
    {value:'claude-3-5-sonnet-20240620',label:'claude-3-5-sonnet-20240620'},
  ])



  
  const state = reactive({
      show: {
        add: false,
        edit: false,
        view: false
      },
      activeComponent: null,
      // 暂存更新数据
      updateData: {},
      // 暂存查看数据
      viewData: {},
      dataList: [],
      // 请求参数
      query: {
        params: {},
        pagination: {
          current: 1,
          pageSize: 50,
          total: 0,
          hideOnSinglePage: true,
        },
        sort: {
          columnKey: "createdAt",
          order: "ascend"
        }
      },
      // loading
      loading: {
        spinning: false,
        tip: '加载中'
      }
    })
  const fileName = ref('')
  const upload = ref<UploadInstance>()
  const fileUp = ref()
  const handleExceed: UploadProps['onExceed'] = (files) => {
    upload.value!.clearFiles()
    const file = files[0] as UploadRawFile
    
    file.uid = genFileId()
    upload.value!.handleStart(file)
    fileName.value = file.name
    
  }
 




  const handleSuccess = (uploadFile: UploadFile) => {
    
  }
  const handleChange = (uploadFile: UploadFile) => {
  // 设置input框的值为上传文件的名称
    fileName.value = uploadFile.name
    console.log("the file is")
    console.log(uploadFile)
    console.log(uploadFile.name)
    fileUp.value = uploadFile.raw
  }
  const submitUpload = () => {
    console.log("begin to upload");
    if(promptsValue.value==""){
        ElMessage.error('请选择清单');
        return;
    }
    if(llmValue.value==""){
        ElMessage.error('请选择模型');
        return;
    }
    //upload.value!.submit()
    var data = new FormData();
    data.append("file", fileUp.value, fileName.value);
    data.append("promptId", promptsValue.value);
    data.append("llm", llmValue.value);

    // create(data).then(res => {
    //    console.log(res);
    // }).catch(err => {
        
    //     console.log(err);
    // })
    var xhr = new XMLHttpRequest();
    xhr.timeout = 10*60*1000; // 设置超时时间为30秒

    xhr.withCredentials = true;
    xhr.responseType = 'blob';
   

    xhr.open("POST", "/api/web/upload");
    // WARNING: Cookies will be stripped away by the browser before sending the request.
   // xhr.setRequestHeader("Cookie", "session=s%3A5NNnyqkNekmg_FglJfGjxzPrwyeCZ_qp.Frjw4ppCqDi8yBmofK4EvuwDHFtde0MDr6wiRHazruM");
   xhr.onload = function() {
    if (this.status === 200) {
      const blob = new Blob([this.response], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      
      a.href = downloadUrl;
      // 如果服务器响应中包含文件名，使用该文件名；否则，自定义文件名
      const contentDisposition = xhr.getResponseHeader('Content-Disposition');
      let filename = 'ret_'+fileName.value;
      if (contentDisposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) { 
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      a.download = filename;
      
      document.body.appendChild(a);
      a.click();
      
      document.body.removeChild(a); // 清理DOM
      URL.revokeObjectURL(downloadUrl); // 释放blob URL
      loadingInstance.close();
    }else{
      ElMessage.error('调用出错：'+this.status);
      loadingInstance.close();
    }
  };

    xhr.send(data);
    const loadingInstance = ElLoading.service({
    lock: true,
    text: '加载中...',
    background: 'rgba(0, 0, 0, 0.7)',
    });
  }
  const getDataList = () => {
      state.loading.spinning = true
      // 将响应式query返回起原始对象
      let p = toRaw(state.query)
  
      promptsList(p).then(res => {
        state.loading.spinning = false
        let datas = res.data.result
        
        state.dataList = datas
        state.query.pagination.total = res.data.total
        state.query.pagination.current = res.data.current
        state.query.pagination.pageSize = res.data.pageSize
        let promptsList = []; 
        for(let item of res.data.result){
            promptsList.push({value:item.id,label:item.name});
        }
        promptsOptions.value = promptsList;
      }).catch(err => {
        state.loading.spinning = false
        console.log(err)
      })
  
    }
    getDataList();

    // 监听selectedValue的变化并更新localStorage
    watch(promptsValue, (newValue) => {
        localStorage.setItem('promptsValue', newValue);
    });
    watch(llmValue, (newValue) => {
        localStorage.setItem('llmValue', newValue);
    });
    // 当组件挂载时，尝试从localStorage读取保存的选择值
    onMounted(() => {
        const savedValue = localStorage.getItem('promptsValue');
        if (savedValue) {
            promptsValue.value = savedValue;
        }
        const savedTwoValue = localStorage.getItem('llmValue');
        if (savedTwoValue) {
            llmValue.value = savedTwoValue;
        }
        
    });

  
return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _createElementVNode("form", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileName).value = $event)),
                        class: "form-control",
                        disabled: "",
                        placeholder: "点击右侧选择文件",
                        style: {"margin":"auto","height":"48px"},
                        id: "file_input"
                      }, null, 512), [
                        [_vModelText, fileName.value]
                      ]),
                      _createVNode(_component_el_upload, {
                        ref_key: "upload",
                        ref: upload,
                        class: "upload-demo",
                        action: "http://localhost:3001/api/web/upload",
                        limit: 1,
                        "on-preview": handleSuccess,
                        "on-change": handleChange,
                        "on-exceed": handleExceed,
                        "auto-upload": false,
                        "show-file-list": false
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            style: {"height":"48px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("请选择文件")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_select, {
                    modelValue: promptsValue.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((promptsValue).value = $event)),
                    filterable: "",
                    placeholder: "请选择清单",
                    style: {"width":"240px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promptsOptions.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: llmValue.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((llmValue).value = $event)),
                    filterable: "",
                    placeholder: "请选择模型",
                    style: {"width":"240px","margin-left":"20px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(llmOptions.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    class: "ml-3",
                    type: "success",
                    onClick: submitUpload,
                    style: {"right":"40px","height":"48px","position":"absolute","width":"100px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 上传 ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})